<div class="header">
  <div class="header__side-control">
    <ng-content select="[leftControls]"></ng-content>
  </div>
  <h1 class="header__title">{{headerTitle}}</h1>
  <div *ngIf="showRightControls" class="header__side-control">
    <ng-content select="[rightControls]"></ng-content>
  </div>
</div>
